export default __webpack_public_path__ + "static/media/snoop.4cefd1d3.gif";